import React, { Component } from 'react';
import { withRouter } from '#/renderer/router';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import product from '~/helpers/product';
import { addonsList } from '~/store/Addons/Addons';

// UI
import UI from './CartSummary.ui';

class CartSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartInfo: {},
      addonsList: [],
    };
  }

  componentDidMount() {
    this.props.orderStore.getCart().then((response) => {
      if (response.success) {
        const prepagoItems = response.data.data.items.filter(it => it.product.type === '1'
          && product.tipoPlan(it.product.items[0]) !== 'SIM');
        const prepagoQuantity = prepagoItems.reduce((qt, it) => qt + +it.quantity, 0);
        if (prepagoQuantity > 1) {
          this.props.history.push('/cart');
        } else {
          this.setState({ cartInfo: response });
        }
      }
    });
    this.addonsList();
  }

  addonsList() {
    addonsList().then((res) => {
      if (res.success) {
        this.setState({
          addonsList: res.data[0].filter(x => x.enabled === true && x.auto_cart === true),
          currentPage: 1,
        });
      }
    });
  }

  render() {
    let cartInfo;
    const orderInfo = this.state.cartInfo;

    if (orderInfo.data && orderInfo.data.data && orderInfo.data.data.items.length) {
      cartInfo = orderInfo.data.data;
    }

    return (
      <UI
        cartInfo={cartInfo}
        addonsList={this.state.addonsList}
      />
    );
  }
}

CartSummary.propTypes = {
  orderStore: PropTypes.shape({
    getCart: PropTypes.func,
    getCartInfo: PropTypes.shape({}),
  }).isRequired,
};

export default inject('orderStore')(observer(withRouter(CartSummary)));
